module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="popup"></span>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/email/RemoveIncompatibleWidgetsView.tpl
// module id = 1776
// module chunks = 0